import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { XenaDSAutocompleteValueAccessorDirective } from './xenads-autocomplete-value-accessor.directive';
import { XenaDSCheckboxValueAccessorDirective } from './xenads-checkbox-value-accessor.directive';
import { XenaDSInputValueAccessorDirective } from './xenads-input-value-accessor.directive';
import { XenaDSInputNumberValueAccessorDirective } from './xenads-input-number-value-accessor.directive';
import { XenaDSSelectValueAccessorDirective } from './xenads-select-value-accessor.directive';

@NgModule({
  declarations: [
    XenaDSAutocompleteValueAccessorDirective,
    XenaDSCheckboxValueAccessorDirective,
    XenaDSInputValueAccessorDirective,
    XenaDSInputNumberValueAccessorDirective,
    XenaDSSelectValueAccessorDirective
  ],
  imports: [CommonModule],
  exports: [
    XenaDSAutocompleteValueAccessorDirective,
    XenaDSCheckboxValueAccessorDirective,
    XenaDSInputValueAccessorDirective,
    XenaDSInputNumberValueAccessorDirective,
    XenaDSSelectValueAccessorDirective
  ]
})
export class DirectivesModule { }
